import Premonish from "premonish";

export default class PreRenderManager {

    defaultConfig = {
        premonish: {
            selectors: ['[data-pre-render="true"]'],
            elements: []
        },
        speculationRules: {
            defaultUrls: ["/find-your-cruise"],
            eagerness: "eager",
        },
        confidence: 1,
        networkThreshold: 1,
    };

    events = {
        onLoad: "pre-render.load",
        refresh: "pre-render.refresh"
    }

    constructor(config = {}) {
        config = {...this.defaultConfig, ...config};
        let eventManager = window.app.eventManager;
        eventManager.createEvent(this.events.refresh,'Pre Render Refresh', 'pre Render is initiated' )
        this.init(config);
        eventManager.subscribe(this.events.refresh, () => { this.init(config) } );
    }

    init(config) {
        // if (this.networkCheck()) {
            this.premonish = new Premonish(config.premonish);
            this.premonish.onIntent(this.onIntent, config);
            this.createSpeculationRules(config.defaultUrls, config.eagerness);
            window.app.eventManager.subscribe(this.events.refresh, () => { this.init(config) } );
        // }
    }

    // networkCheck() {
    //     return navigator.connection.effectiveType === '4g';
    // }

    createSpeculationRules(urls, eagerness) {
        if (
            HTMLScriptElement.supports &&
            HTMLScriptElement.supports("speculationrules")
        ) {
            const specScript = document.createElement("script");
            specScript.type = "speculationrules";

            const specRules = {
                prerender: [
                    {
                        urls: urls,
                        eagerness: eagerness
                    },
                ],
            };
            specScript.textContent = JSON.stringify(specRules);
            document.body.append(specScript);
        }
    }

    removeSpeculationRules() {
        const ruleScript = document.querySelector('script[type="speculationrules"]');
        if (ruleScript) {
            ruleScript.remove();
        }
    }

    onIntent = (intent, config = this.defaultConfig) => {
        if (intent.confidence === config.confidence) {
            let pageUrl = intent.el.href;
            this.preRender(pageUrl);
        }

    }


    preRender(pageUrl) {
        this.removeSpeculationRules();
        this.createSpeculationRules([pageUrl]);
    }
}